import React from "react";
import { Icon } from "@zorni/components-lib";
import { useNavigate } from "react-router-dom";
import { useZorni } from "../../../hooks/useZorni";
import { useNotifications } from "../../../hooks/NotificationContext";
import { clearVisitedTrips } from "../../tripDetails/detailsTrip/hooks/useVisitedTrips";
import styles from "./ProfilToggle.module.css";

const ProfilToggle = ({ onSelect }) => {
  const { keycloak } = useZorni();
  const navigate = useNavigate();
  const { hasNewMessages, hasNewReservations } = useNotifications();

  const handleChange = (action) => {
    onSelect?.();

    switch (action) {
      case "profil":
        navigate("/profil");
        break;
      case "myTrips":
        navigate("/my-trips");
        break;
      case "favorites":
        navigate("/favorites");
        break;
      case "messenger":
        navigate("/messenger");
        break;
      default:
        // Avant logout() : Keycloak redirige et le .then() peut ne jamais s'exécuter.
        clearVisitedTrips();
        keycloak
          .logout()
          .then(() => {
            navigate("/home");
          })
          .catch((error) => {
            console.error("Logout failed:", error);
          });
        break;
    }
  };

  return (
    /**
     * IMPORTANT :
     * On ne met PLUS de .dropdown-menu / .dropdown-item (Bootstrap)
     * → le Header se charge déjà de la bulle et du positionnement
     */
    <div className={styles.panel} aria-label="Menu utilisateur">
      {/* Profil */}
      <button
        type="button"
        className={styles.item}
        onClick={() => handleChange("profil")}
      >
        <span className={styles.iconWrapper}>
          <Icon name="iconUser" className={styles.icon} />
        </span>
        <span className={styles.label}>Profile</span>
      </button>

      <div className={styles.divider} />

      {/* Voyages */}
      <button
        type="button"
        className={styles.item}
        onClick={() => handleChange("myTrips")}
      >
        <span className={styles.iconWrapper}>
          <Icon name="iconPlaneDeparture" className={styles.icon} />
          {hasNewReservations && (
            <span className={styles.badge} aria-label="Nouvelles réservations" />
          )}
        </span>
        <span className={styles.label}>Voyages</span>
      </button>

      <div className={styles.divider} />

      {/* favorites */}
      <button
        type="button"
        className={styles.item}
        onClick={() => handleChange("favorites")}
      >
        <span className={styles.iconWrapper}>
          <Icon name="iconFavoriteRegular" className={styles.icon} />
        </span>
        <span className={styles.label}>Favorites</span>
      </button>

      <div className={styles.divider} />

      {/* messages */}
      <button
        type="button"
        className={styles.item}
        onClick={() => handleChange("messenger")}
      >
        <span className={styles.iconWrapper}>
          <Icon name="iconEnvelope" className={styles.icon} />
          {hasNewMessages && (
            <span className={styles.badge} aria-label="Nouveaux messages" />
          )}
        </span>
        <span className={styles.label}>Messages</span>
      </button>

      <div className={styles.divider} />

      {/* Logout */}
      <button
        type="button"
        className={styles.item}
        onClick={() => handleChange("logout")}
      >
        <span className={styles.iconWrapper}>
          <Icon name="iconSignOut" className={styles.icon} />
        </span>
        <span className={styles.label}>Logout</span>
      </button>
    </div>
  );
};

export default ProfilToggle;
